import React from 'react';
import PropTypes from 'prop-types';

function OptionsButton({ active, activeColor, border, color }) {
  return (
    <>
      <path
        d="M577.186 142.227C573.578 142.182 570.333 144.664 569.537 148.334L565.053 169.02C564.144 173.213 566.788 177.321 570.982 178.231L572.725 178.609C576.918 179.518 581.026 176.874 581.935 172.681L586.42 151.993C587.329 147.8 584.685 143.692 580.492 142.783L578.748 142.405C578.224 142.292 577.701 142.233 577.186 142.227Z"
        fill={active ? activeColor : color}
      />
      <path
        d="M577.328 141.642C573.38 141.592 569.823 144.319 568.955 148.323L564.47 169.009C563.478 173.584 566.38 178.092 570.956 179.084L572.7 179.463C577.276 180.455 581.784 177.553 582.776 172.977L587.261 152.291C588.253 147.716 585.35 143.208 580.775 142.216L579.035 141.837H579.031C578.461 141.713 577.891 141.65 577.329 141.642H577.328ZM577.309 143.098C577.776 143.104 578.245 143.156 578.722 143.259L580.467 143.638C584.278 144.465 586.665 148.172 585.839 151.983L581.353 172.669C580.527 176.481 576.82 178.867 573.008 178.041L571.268 177.662C571.267 177.662 571.266 177.662 571.265 177.662C567.454 176.835 565.071 173.128 565.898 169.317L570.383 148.631C571.106 145.296 574.041 143.056 577.31 143.098H577.309Z"
        fill={border}
      />
    </>
  );
}

OptionsButton.propTypes = {
  active: PropTypes.bool,
  activeColor: PropTypes.string,
  border: PropTypes.string,
  color: PropTypes.string,
};

OptionsButton.defaultProps = {
  active: false,
  activeColor: '#000000',
  border: '#919191',
  color: '#DEE2EB',
};

export default OptionsButton;
